// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { SmallHeadingAndTextStyles } from "@insite/content-library/Components/SmallHeadingAndText";
import { rfqQuoteDetailsQuoteLineCalculatorStyles } from "@insite/content-library/Widgets/RfqQuoteDetails/RfqQuoteDetailsQuoteLineCalculator";
import { getNotifyStyle } from "@sc/App/Components/Notify";
import cartLineSharedStyles from "@sc/App/SharedStyles/CartLineSharedStyles";
import { mergeWithCss, xScreen } from "@sc/XDL/Utilities";
import { css } from "styled-components";

const heading: SmallHeadingAndTextStyles = {
    heading: {
        size: 16,
        weight: "bold",
        transform: "none",
        css: css`
            margin-bottom: 0;
        `,
    },
};

rfqQuoteDetailsQuoteLineCalculatorStyles.resetButton = {
    variant: "secondary",
    css: css`
        margin-right: 10px;
    `,
};

rfqQuoteDetailsQuoteLineCalculatorStyles.productDescription = {
    ...cartLineSharedStyles.productDescription,
};

rfqQuoteDetailsQuoteLineCalculatorStyles.qtyHeader = {
    css: css`
        // Undo sticky table from prestyles
        ${xScreen("lte", "sm")} {
            &&& {
                position: static;
            }
        }
    `,
};

rfqQuoteDetailsQuoteLineCalculatorStyles.unitCostGridItem = {
    width: [6, 6, 6, 3, 3],
};

rfqQuoteDetailsQuoteLineCalculatorStyles.listPriceGridItem = {
    width: [6, 6, 6, 3, 3],
};

rfqQuoteDetailsQuoteLineCalculatorStyles.customerPriceGridItem = {
    width: [6, 6, 6, 3, 3],
};

rfqQuoteDetailsQuoteLineCalculatorStyles.minimumPriceAllowedGridItem = {
    width: [6, 6, 6, 3, 3],
};

rfqQuoteDetailsQuoteLineCalculatorStyles.errorText = {
    ...mergeWithCss(getNotifyStyle("danger"), {
        css: css`
            margin-top: 10px;
        `,
    }),
};

rfqQuoteDetailsQuoteLineCalculatorStyles.unitCostHeadingAndText = {
    ...heading,
};

rfqQuoteDetailsQuoteLineCalculatorStyles.listPriceHeadingAndText = {
    ...heading,
};

rfqQuoteDetailsQuoteLineCalculatorStyles.customerPriceHeadingAndText = {
    ...heading,
};

rfqQuoteDetailsQuoteLineCalculatorStyles.minimumPriceAllowedHeadingAndText = {
    ...heading,
};

rfqQuoteDetailsQuoteLineCalculatorStyles.qtyAvailableHeadingAndText = {
    ...heading,
};

rfqQuoteDetailsQuoteLineCalculatorStyles.buttonsGridItem = {
    width: 12,
    css: css`
        justify-content: flex-end;
        ${xScreen("lte", "xs")} {
            flex-direction: column;
            gap: 10px;
            button {
                width: 100%;
            }
        }
    `,
};

rfqQuoteDetailsQuoteLineCalculatorStyles.itemPricingHeader = {
    variant: "h5",
    css: css`
        margin: 20px 0 5px 0;
    `,
};
